import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PioActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class PioEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getPio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PioActions.getPio),
      switchMap((action) =>
        this.onboardingProductsService.getPio().pipe(
          map((res) => this.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            PioActions.getPioSucess({ response: res })
          ),
          catchError((error) =>
            of(
              PioActions.getPioError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    res = res['response'];
    const response = res;
    if (
      _.get(res, 'status.code', '') === 200 ||
      _.get(res, 'status.code', '') === 202 ||
      _.get(res, 'status.code', '') === 204
    ) {
      console.log('evaluando la respuesta de pio');
      if (_.get(res, 'middleware', null)) {
        response['middleware'] = _.get(res, 'middleware', null);
        console.log('modificando el response de pio');
      }
    }
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }

  isDate18orMoreYearsOld = (day, month, year) => {
    return new Date(year + 18, month - 1, day) <= new Date();
  }
}
